import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import React from 'react';

import { ILayoutProps } from '~/src/dash/components/layout/common';
import { Div } from '~/src/dash/components/layout/Div';

interface IInfoTooltipIconProps extends ILayoutProps {
  iconWidth?: string;
  iconColor?: string;
  tooltipText?: string;
  tooltipPlacement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

export const InfoTooltipIcon = ({
  style,
  iconWidth = '1rem',
  iconColor = '929599',
  tooltipText = '',
  tooltipPlacement = 'bottom-start',
}: IInfoTooltipIconProps) => {
  return (
    <Div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Tooltip title={tooltipText} placement={tooltipPlacement}>
        <InfoIcon style={{ width: iconWidth, color: iconColor, ...style }} />
      </Tooltip>
    </Div>
  );
};
